import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { Builders } from 'q3-ui-forms';
import ExtensionIcon from '@material-ui/icons/Extension';
import CategoryIcon from '@material-ui/icons/Category';
import LabelIcon from '@material-ui/icons/Label';
import ProductsFiltersLoaderAndForm from './ProductsFiltersLoaderAndForm';

const ATTRIBUTES = [
  'featured',
  'recommended',
  'promotion',
  'new',
];

const ProductsFilter = ({ query }) => (
  <Grid item>
    <Grid container spacing={2}>
      <Grid item>
        <ProductsFiltersLoaderAndForm
          icon={CategoryIcon}
          field="category~code"
          route="categories"
          query={query}
        />
      </Grid>
      <Grid item>
        <ProductsFiltersLoaderAndForm
          icon={ExtensionIcon}
          field="vendor~code"
          route="vendors"
          query={query}
        />
      </Grid>
      <Grid item>
        <ProductsFiltersLoaderAndForm
          icon={LabelIcon}
          query={query}
          countFunction={(d) =>
            ATTRIBUTES.reduce(
              (acc, curr) =>
                acc + (d && curr in d) ? 1 : 0,
              0,
            )
          }
        >
          {() =>
            ATTRIBUTES.map((attribute) => (
              <Builders.Field
                name={attribute}
                key={attribute}
                suppressHelper
                type="checkbox"
                variant="switch"
                checkedValue="exists(true)"
                label={`Is ${attribute}`}
              />
            ))
          }
        </ProductsFiltersLoaderAndForm>
      </Grid>
    </Grid>
  </Grid>
);

ProductsFilter.propTypes = {
  query: PropTypes.string.isRequired,
};

export default ProductsFilter;
